import React from 'react';
import NodeKPAnswerPageFull from './Full';
import NodeKPAnswerPageTeaser from './Teaser';

const NodeKPAnswerPage = (props) => {
  const { viewMode } = props;
  switch (viewMode) {
    case 'teaser':
      return <NodeKPAnswerPageTeaser {...props} />;

    default:
      return <NodeKPAnswerPageFull {...props} />;
  }
};

export default NodeKPAnswerPage;
